import './DefaultFooter.less';
import React from 'react';
import __ from "../../../i18n";
import LocaleSwitcher from "../../locale-switcher/LocaleSwitcher";
import {Link} from "react-router-dom";
import routes from "../../../routing/routes";
import config from '../../../../../../config.json';
import Logo from "../../../widgets/logo/Logo";
import Icon from "../../../../bootstrap/components/icon/Icon";


export default function DefaultFooter({}) {

    return <div className="default-footer">
        <div className="inner">
            <div className="row">
                <div className="col">
                    <div className="header">
                        <Link to={routes.home.getUrl()}>
                            <Logo/>
                        </Link>
                        <div className="title">
                            {config.metadata.footerTitle}
                        </div>
                    </div>
                    <table>
                        <tbody>
                        {
                            config.places.map((place) => <tr key={place.address}>
                                <th>
                                    <Icon name="map-marker"/>
                                </th>
                                <td>
                                    {place.address}
                                </td>
                            </tr>)
                        }
                        <tr>
                            <th>
                                <Icon name="phone"/>
                            </th>
                            <td>
                                {
                                    config.phones.map(t => t.number).join(', ')
                                }
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <Icon name="envelope"/>
                            </th>
                            <td>
                                {
                                    config.emails.map(t => t.address).join(', ')
                                }
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="col">
                    <table>
                        <tbody>
                        <tr>
                            <td>
                                <Link to={routes.article.getUrl('ve-chung-toi')}>{__('About us')}</Link>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <Link to={routes.article.getUrl('dieu-khoan-su-dung')}>{__('Terms of use')}</Link>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <Link to={routes.article.getUrl('chinh-sach-bao-mat')}>{__('Privacy policy')}</Link>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <Link to={routes.article.getUrl('huong-dan-thanh-toan')}>{__('Payment instructions')}</Link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="col">
                    <LocaleSwitcher/>
                    <div className="copyright">
                        {
                            __('© ::year ::site', {
                                site: config.metadata.name,
                                year: String(new Date().getFullYear())
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>;
}
